import { dataTemplate } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTemplate = /*#__PURE__*/createIcon(dataTemplate)
export default IconTemplate
